<template>
    <h5>Generar clave aleatoria</h5>
    <Form role="form" class="text-start mt-4" :validation-schema="schema" @submit="handleCambioClaveUsuario"> 

        <soft-field id="username" v-model="usuarioEditusername" type="text" :useLabel="true" label="Usuario" name="username" class="mb-2 label-input2" largo="30" readonly="readonly"/>

        <soft-field id="email" v-model="usuarioEditemail" type="email" :useLabel="true" label="Email" name="email" class="mb-2 label-input2" readonly=true />
        
        <div class="mt-5">
            <QToggle v-model="indemail" />
            <label for="enviar-email">Enviar clave por email</label>
        </div>
        <div v-if="!indemail" class="alert alert-warning mt-2 py-2 px-3" style="font-size:0.82rem;">
            ⚠️ La clave se mostrará aquí una sola vez. Anótala antes de cerrar.
        </div>
  
        <QBtn type="submit" variant="tipster" label="Confirmar" :loading="loading" class="float-end mt-3" />
    </Form>
  </template>
  
  <script>
  import SoftField from "@/components/SoftField.vue";
  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";
  //import * as yup from "yup";

  export default {
    name: "AltaUsuarioForm",
    components: {
        SoftField,
        Form,
    },
    props: {
        usuarioId: Number,
        usuarioUsername: String,
        usuarioEmail: String
    },
    data() {
    /*  const schema = yup.object().shape({
            email: yup.string().required("El email es necesario!").email("Debe indicar un email válido"),
            username: yup.string().required("El usuario es necesario!").max(30,'El tamaño máximo es de 30 caracteres').matches(/^[a-zA-Z0-9.-]+$/, 'El usuario contiene caracteres no permitidos'),
            nombre: yup.string().required("El nombre es necesario!").max(80,'El tamaño máximo es de 80 caracteres'),
            rol_id: yup.number().positive('Debe indicar un rol')
        }); */
        return {
            loading: false,
            user:{},
        //    schema,
            usuarioEditusername: this.usuarioUsername,
            usuarioEditemail: this.usuarioEmail,
            indemail: false,
        };
    },
    emits: ['cerrar-modal'],
    methods: {
      async handleCambioClaveUsuario() {
        // Aquí puedes realizar acciones cuando se envía el formulario
        this.loading = true;
        try {
            this.loading = false;
            const resp = await this.$store.dispatch("auth/generarClaveUsuario", {id: this.usuarioId, indemail: this.indemail});
            if (resp.res=='OK') {
                showSwal.methods.showSwal({
                    type: "success",
                    message: resp.mensaje,
                    width: 600,
                    timer: 12000
                });
                this.$emit('cerrar-modal');
            }
            else {
                showSwal.methods.showSwal({
                    type: "error",
                    message: resp.mensaje,
                    width: 500
                });               
            }
        } catch (error) {
            this.loading = false;
            showSwal.methods.showSwal({
                type: "error",
                message: "Se ha producido un error",
                width: 500,
            });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos específicos del componente MyForm */
  </style>